{
  "cognito_user_pool_endpoint": "cognito-idp.eu-central-1.amazonaws.com/eu-central-1_LnBEP9sr1",
  "cognito_user_pool_client_id": "751p2mljr7ba6kdddocg6og0gs",
  "domain": "dev.kleksi.dev",
  "short_domain": "pid.dev.kleksi.dev",
  "servers": [
    {
      "id": "eu",
      "region": "eu-central-1"
    }
  ]
}
